import { useTranslation } from "react-i18next";
import { EmailTagInputProps } from "./EmailTagInput.types";
import { useEmailTagInput } from "./useEmailTagInput";
import "./EmailTagInput.style.css";

export function EmailTagInput({
  value,
  onChange,
  disabled = false,
  placeholder,
  maxEmails = 20,
  className = "",
}: EmailTagInputProps) {
  const { t } = useTranslation();
  const {
    inputValue,
    emailTags,
    handleInputChange,
    handleKeyDown,
    handlePaste,
    removeEmail,
    clearAll,
    isAtLimit,
  } = useEmailTagInput({ value, onChange, maxEmails, disabled });

  return (
    <div className={`email-tag-input-container ${className}`}>
      <div className="email-tag-input-wrapper">
        <div className="email-tags-list">
          {emailTags.map((tag, index) => (
            <span
              key={index}
              className="email-tag-badge"
            >
              <span className="email-tag-text">{tag.email}</span>
              {!disabled && (
                <button
                  type="button"
                  className="email-tag-remove"
                  onClick={() => removeEmail(index)}
                  aria-label={`Remove ${tag.email}`}
                >
                  ×
                </button>
              )}
            </span>
          ))}
        </div>
        
        <div className="email-tag-input-row">
          <input
            type="text"
            className="email-tag-input"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            disabled={disabled || isAtLimit}
            placeholder={
              isAtLimit
                ? t("EMAIL_TAG_INPUT.MAX_LIMIT_REACHED", { max: maxEmails })
                : placeholder || ""
            }
          />
          
          {value.length > 0 && !disabled && (
            <button
              type="button"
              className="email-tag-clear-all"
              onClick={clearAll}
              title={t("EMAIL_TAG_INPUT.CLEAR_ALL")}
            >
              {t("EMAIL_TAG_INPUT.CLEAR_ALL")}
            </button>
          )}
        </div>
      </div>
      
      <div className="email-tag-info">
        <small className="text-muted">
          {t("EMAIL_TAG_INPUT.COUNT", { current: value.length, max: maxEmails })}
        </small>
      </div>
    </div>
  );
}
